(function () {
  'use strict';

  function init(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const form = root.querySelector('[data-track-order-form]');
    const submit = root.querySelector('[data-track-order-submit]');
    const message = root.querySelector('[data-track-order-message]');
    const result = root.querySelector('[data-track-order-result]');
    const demoMode = root.dataset.demoMode === 'true';
    const service = new window.TrackingService({ demoMode });

    function showMessage(text, isError) {
      message.textContent = text;
      message.classList.toggle('track-order__message--error', Boolean(isError));
      message.hidden = false;
    }

    function render(data) {
      root.querySelectorAll('[data-track-field]').forEach(function (field) {
        field.textContent = data[field.dataset.trackField] || '—';
      });

      root.querySelectorAll('[data-track-stage]').forEach(function (stage) {
        const index = Number(stage.dataset.trackStage);
        stage.classList.toggle('is-complete', index < data.currentStage);
        stage.classList.toggle('is-current', index === data.currentStage);
        if (index === data.currentStage) stage.setAttribute('aria-current', 'step');
        else stage.removeAttribute('aria-current');
      });

      const demoLabel = root.querySelector('[data-track-demo-label]');
      demoLabel.hidden = !data.isDemo;

      const shipmentLink = root.querySelector('[data-track-shipment-link]');
      if (data.shipmentUrl) {
        shipmentLink.href = data.shipmentUrl;
        shipmentLink.hidden = false;
      } else {
        shipmentLink.hidden = true;
      }

      result.hidden = false;
      result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      message.hidden = true;
      result.hidden = true;

      const orderInput = form.elements.orderId;
      const contactInput = form.elements.contact;
      [orderInput, contactInput].forEach(function (input) {
        input.setAttribute('aria-invalid', String(!input.value.trim()));
      });

      if (!orderInput.value.trim() || !contactInput.value.trim()) {
        showMessage('Please enter both your order ID and the email or phone number used at checkout.', true);
        (!orderInput.value.trim() ? orderInput : contactInput).focus();
        return;
      }

      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const tracking = await service.lookup({
          orderId: orderInput.value.trim(),
          contact: contactInput.value.trim()
        });
        render(tracking);
      } catch (error) {
        if (error instanceof window.TrackingUnavailableError) {
          showMessage(root.dataset.unavailableMessage, false);
        } else {
          showMessage('We could not check this order right now. Please try again later.', true);
        }
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  }

  function initAll(container) {
    (container || document).querySelectorAll('[data-track-order]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
